import script from "./ReferralsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferralsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ReferralsPage.vue?vue&type=style&index=0&id=13f62af2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13f62af2"]])

export default __exports__